<!--
******************************
 * @author Jesus R. Nava Cruz
 * @date May 24, 2023
 * @version 1.0
******************************
-->
<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="list"
      :items-per-page="itemsPerPage"
      no-data-text="Sin resultados disponibles"
      dense
      fixed-header
      hide-default-footer
    >
      <template v-slot:[`item.actions`]="{ item, index }">
        <v-tooltip top :index="index">
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon @click="get(item, 3)">
              <v-icon color="warning" v-bind="attrs" v-on="on">
                mdi-pencil
              </v-icon>
            </v-btn>
          </template>
          <span>Editar Producto</span>
        </v-tooltip>
        <v-tooltip top :index="index">
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon @click="handleDeleteItem(item)">
              <v-icon color="error" v-bind="attrs" v-on="on">
                mdi-delete
              </v-icon>
            </v-btn>
          </template>
          <span>Eliminar</span>
        </v-tooltip>
      </template>
    </v-data-table>
    <v-dialog
      v-model="dialogCancelation"
      v-if="dialogCancelation"
      persistent
      max-width="30%"
    >
    </v-dialog>
  </div>
</template>
<script>
export default {
  name: "ProductsTable",
  props: {
    list: Array,
    get: Function,
    deleteItem: Function,
    update: Function,
    itemsPerPage: Number,
    listAllPagination: Function,
  },
  data: () => ({
    headers: [
      {
        text: "Id Producto",
        value: "idProduct",
        sortable: false,
      },
      {
        text: "Clave",
        value: "productKey",
        sortable: false,
      },
      {
        text: "Nombre",
        value: "name",
        sortable: false,
      },
      {
        text: "Descripción",
        value: "description",
        sortable: false,
      },
      {
        text: "Acciones",
        value: "actions",
        sortable: false,
      },
    ],
    dataModal: {},
    dialogCancelation: false,
  }),
  methods: {
    handleDeleteItem(item) {
      this.dialogCancelation = true;
      this.$swal({
        toast: true,
        title: "¿Eliminar producto?",
        text: "",
        icon: "warning",
        confirmButtonText: "Confirmar",
        showCancelButton: true,
        cancelButtonText: "Cancelar",
        reverseButtons: true,
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false,
      }).then((result) => {
        if (result.value) {
          this.dialogCancelation = false;
          this.deleteItem(item);
        } else {
          this.dialogCancelation = false;
        }
      });
    },
  },
};
</script>